import { render, staticRenderFns } from "./DialogInfoCancelados.vue?vue&type=template&id=e00616cc&lang=pug"
import script from "./DialogInfoCancelados.vue?vue&type=script&lang=js"
export * from "./DialogInfoCancelados.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports